import { useUserConfig } from '@littlebird/sdk';

// The server's default, which must match `ProactiveAgentsConfig.borderline_cards`. The app shows it only
// until it has received the user's own value.
const DEFAULT_BORDERLINE_CARDS = 75;

/** How readily the agent's routines create cards for things that may or may not deserve one, from 0 to 100 */
export const useBorderlineCards = () => {
  // React Compiler would cache the settings store read and miss its changes.
  'use no memo';

  const userConfig = useUserConfig();
  return {
    borderlineCards:
      userConfig.proactiveAgents.get('borderline_cards') ??
      DEFAULT_BORDERLINE_CARDS,
    setBorderlineCards: (value: number) =>
      userConfig.proactiveAgents.set('borderline_cards', value),
  };
};
